import { hasActiveUploads } from './helpers/hasActiveUploads';
import { trackAction } from '../../libs/analytics/ActionTracking';

window.addEventListener('beforeunload', (event) => {
  if (hasActiveUploads()) {
    event.preventDefault();
    trackAction('User is about to close the tab', null);
    event.returnValue = 'You have active uploads. Are you sure you want to leave?';
  }
});
